"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setConfig = void 0;
var config_1 = require("./config");
var setConfig = function (props) {
    var _a = props.apiPath, apiPath = _a === void 0 ? '/consent' : _a, _b = props.clientVersion, clientVersion = _b === void 0 ? 1 : _b, _c = props.clientId, clientId = _c === void 0 ? 'rvuconsent' : _c, _d = props.brand, brand = _d === void 0 ? 'money' : _d;
    return config_1.default.setNewConfigValues({
        path: apiPath,
        version: clientVersion,
        id: clientId,
        brand: brand,
    });
};
exports.setConfig = setConfig;
